import { apiClient } from 'src/app/common/network';

const ADMIN_URL = `${window.envConfig['REACT_APP_APIM_BASE_URL']}${window.envConfig['REACT_APP_APIM_ADMIN']}`;

export const getEventInvitationList = async (params?: any) => {
  return apiClient.get(`${ADMIN_URL}/events/invitation/list`, {
    params,
  });
};
